import type { CursorPagination, CursorPaginationParams } from './base'

export interface Store {
  storeName: string
  storeOrgNumber: string
  storeID: string
  storePhone: string
  storeAddress: string
  storeEmail: string
  orgID?: string
}

export type TypeStoreStatus = 'Active' | 'Inactive' | 'Blacklisted'
export enum EnumStoreStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Blacklisted = 'Blacklisted',
}

export interface Stores {
  userID?: string
  roleID?: string
  orgID?: string
  storeID?: string
  storeName?: string
  storeWebSite?: string
  storeVatNumber?: string
  storeFSkatt?: boolean
  storeOrgNumber?: string
  storeStatus?: TypeStoreStatus
  storeEmail?: string
  storePhone?: string
  storeAddress?: string
  storeZipCode?: string
  storeCity?: string
  storeCountry?: string
  storeDescription?: string
  storeContactPerson?: string
  storeMaxUsers?: number
  currency?: string
  storeAllowCarAPI?: boolean
  storeAllowSendSMS?: boolean
  storeSendSMS?: boolean
  storeUsesCheckin?: boolean
  storeUsesPIN?: boolean
  storePaymentOptions?: {
    bankgiro?: string
    plusgiro?: string
    paymentdays?: number
  }
}

export interface StoreListParams extends CursorPaginationParams {
  orgID?: string
}

export interface StoresData extends CursorPagination {
  stores: Stores[]
}

export interface StoreData extends CursorPagination {
  store: Stores
  storePaymentOptions: string[]
}
